declare global {
  var _debug: (enabled: boolean) => void;
  var _isDebugging: boolean;
  var vtlog: (...args: any[]) => void;
}

window._isDebugging = localStorage.getItem('_debug') === 'true';

window._debug = (enabled: boolean) => {
  localStorage.setItem('_debug', enabled ? 'true' : 'false');
  window._isDebugging = enabled;
  const event = new Event('debugChange');
  window.dispatchEvent(event);
};

const vtlog = (...args: any[]) => {
  if (window._isDebugging || import.meta.env.MODE === 'development') {
    console.debug(...args);
  }
};

window.vtlog = vtlog;

export {};
